import { useLoginLink } from 'hooks/useLoginLink';
import * as S from './inc-login-link.styles';

const IncLoginLink = ({ label, ...rest }) => {
  const handleLoginLinkClick = useLoginLink();

  return (
    <S.StyledIncLoginLink
      component="button"
      variant="body1"
      onClick={handleLoginLinkClick}
      {...rest}
    >
      {label}
    </S.StyledIncLoginLink>
  );
};

export default IncLoginLink;
